<template>
  <agile :options="options">
    <slot></slot>
    <template slot="prevButton"
      ><img src="@/assets/svg/slider_left.svg"
    /></template>
    <template slot="nextButton"
      ><img src="@/assets/svg/slider_right.svg"
    /></template>
  </agile>
</template>

<script>
export default {
  data() {
    return {
      options: {
        navButtons: false,
        dots: true,
        responsive: [
          {
            breakpoint: 720,
            settings: {
              navButtons: true,
            },
          },
        ],
        fade: this.$store.state.isIeOrEdge,
      },
    };
  },
};
</script>

<style lang="scss">
@import "@/assets/scss";
.agile {
  position: relative;
  user-select: none;
  &__actions {
    @include flex-h(space-between, center);
  }
  &__nav {
    &-button {
      @include margin-h(20px);
      position: absolute;
      top: 0;
      bottom: 0;
      &--next {
        right: 0;
      }
      &--prev {
        left: 0;
      }
      img {
        display: block;
        @include size(60px);
        @include breakpoint(xs) {
          @include size(40px);
        }
        @include breakpoint(s) {
          @include size(50px);
        }
      }
    }
  }
  &__dots {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 10px;
    @include flex-h(center, center);
  }
  &__dot {
    height: 3px;
    width: 30px;
    border-radius: 13px;
    background-color: black;
    @include margin-h(5px);
    &--current {
      background-color: white;
    }
  }
}
</style>
